import { readable, writable, derived, get } from 'svelte/store';
import { getContext, setContext } from 'svelte';

/**
* Retourne la Location courante.
*
* @returns {Location} Location object
* @private
*/
function getLocation() {

    const hashPosition = window.location.href.indexOf('#/');
    let location = (hashPosition > -1) ? window.location.href.substr(hashPosition + 1) : '/';

    // Check if there's a querystring
    const qsPosition = location.indexOf('?');
    let querystring = '';
    if (qsPosition > -1) {
        querystring = location.substr(qsPosition + 1);
        location = location.substr(0, qsPosition);
    }

    return { location, querystring };
}

/**
* Store retournant la Location courante (location+querystring).
*/
export const loc = readable(
    getLocation(),
    function start(set) {
        const update = () => {
            set(getLocation());
        }
        window.addEventListener('hashchange', update, false);

        update();

        return function stop() {
            window.removeEventListener('hashchange', update, false);
        }
    }
)

/**
* Store retournant le path courant
*/
export const location = derived(
    loc,
    ($loc) => $loc.location
)

/**
* Store retournant la querystring courante.
*/
export const querystring = derived(
    loc,
    ($loc) => $loc.querystring
)

/**
* Navigation vers une nouvelle URL.
*
* @param {string} location - Destination (doit commencer par / ou #/)
* @param {boolean} replace
*/
export function push(location, replace) {

    if (replace === undefined) {
        replace = false;
    }

    console.log("Navigating to " + location + (replace ? " [replace]" : ""));

    if (!location || location.length < 1 || (location.charAt(0) != '/' && location.indexOf('#/') !== 0)) {
        throw Error('Invalid parameter location')
    }

    setTimeout(() => {
        if (replace) {
            const dest = (location.charAt(0) == '#' ? '' : '#') + location;

            history.replaceState(history.state, undefined, dest);
            window.dispatchEvent(new Event('hashchange'));
        } else {
            window.location.hash = (location.charAt(0) == '#' ? '' : '#') + location;
        }
    }, 0);
}

/**
* Back.
*/
export function pop() {
    setTimeout(() => {
        window.history.back()
    }, 0)
}

/**
* Remplace l'URL courante, sans changer l'historique de navigation.
*
* @param {string} location - Destination (doit commencer avec `/` or '#/')
*/
export function replace(location) {
    push(location, true);
}

/**
*
 * @param {Record<string,any>} target
 * @param {string} q
 */
function parseQueryString(target, q) {
    if (!q || q === "") {
        return;
    }

    for (const param of q.split('&')) {
        let pos = param.indexOf('=');
        if (pos < 0) {
            target[param] = null;
        } else {
            let key = param.substr(0, pos);
            /** @type {any} */
            let value = param.substr(pos + 1);

            // conversion si possible
            let vnum = Number(value);
            if (!Number.isNaN(vnum)) {
                value = vnum;
            } else {
                const vlc = value.toLowerCase();
                if (vlc === 'true' || vlc === 'false') {
                    value = vlc === 'true';
                }
            }

            target[key] = value;
        }
    }
}

